'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class; /* global window */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _mobxReact = require('mobx-react');

var _slide = require('@dekk/slide');

var _slide2 = _interopRequireDefault(_slide);

var _url = require('@dekk/url');

var _utils = require('@dekk/utils');

var _countdown = require('@dekk/countdown');

var _countdown2 = _interopRequireDefault(_countdown);

var _deck = require('@dekk/deck');

var _deck2 = _interopRequireDefault(_deck);

var _speakerWrapper = require('./speaker-wrapper');

var _speakerWrapper2 = _interopRequireDefault(_speakerWrapper);

var _controls = require('./controls');

var _controls2 = _interopRequireDefault(_controls);

var _views = require('./views');

var _views2 = _interopRequireDefault(_views);

var _notes = require('./notes');

var _notes2 = _interopRequireDefault(_notes);

var _layouts = require('./layouts');

var _layouts2 = _interopRequireDefault(_layouts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Styles for the speaker-dek.
 * handles dark and light theme.
 * @private
 */
var presenterStyles = (0, _styledComponents.css)(['background:', ';color:', ';'], function (_ref) {
  var theme = _ref.theme;
  return theme === 'dark' ? '#111' : '#eee';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme === 'dark' ? '#fff' : '#000';
});

/**
 * Displays ` n / m` strings.
 *
 * @private
 * @param {number} n
 * @param {Array} arr
 * @param {number} arr.length
 * @return {String}
 */
var nOf = function nOf(n, _ref3) {
  var length = _ref3.length;
  return n + (length > 0 ? 1 : 0) + ' / ' + Math.max(0, length);
};

/**
 * A wrapper around the slides.
 * `<SpeakerDeck/>` displays the slides in various layouts
 *
 *
 * @class SpeakerDeck
 * @param {Object} props
 *   The properties
 * @param {(Slide|Slide[]|Elements|Elements[]|Plugins|Plugins[])} props.children
 * @param {?(String|Array)} props.mixin
 * @param {number} props.timer
 * @param {number} [props.timerWarning=0]
 *
 * @example
 * import React from 'react'
 * import {SpeakerDeck} from '@dekk/deck'
 * import Slide from '@dekk/slide'
 *
 * const App = () => (
 *   <SpeakerDeck>
 *     <Slide>1</Slide>
 *     <Slide>2</Slide>
 *     <Slide>3</Slide>
 *   </SpeakerDeck>
 * )
 */

var SpeakerDeck = (0, _mobxReact.observer)(_class = function (_Deck) {
  _inherits(SpeakerDeck, _Deck);

  _createClass(SpeakerDeck, null, [{
    key: 'propTypes',

    /**
     * @private
     */
    get: function get() {
      return {
        mixin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
        children: _propTypes2.default.node.isRequired,
        timer: _propTypes2.default.number,
        timerWarning: _propTypes2.default.number
      };
    }

    /**
     * @private
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        timer: 30,
        timerWarning: 0,
        mixin: ''
      };
    }

    /**
     * @param {Object} props
     *   The properties
     * @param {(Slide|Slide[]|Elements|Elements[]|Plugins|Plugins[])} props.children
     * @param {?(String|Array)} props.mixin
     * @param {number} props.timer
     * @param {number} [props.timerWarning=0]
     *
     */

  }]);

  function SpeakerDeck(props) {
    _classCallCheck(this, SpeakerDeck);

    /**
     * Data from url
     * @private
     */
    var _this = _possibleConstructorReturn(this, (SpeakerDeck.__proto__ || Object.getPrototypeOf(SpeakerDeck)).call(this, props));

    var _search$parse = _url.search.parse(window.location.href),
        _search$parse$layout = _search$parse.layout,
        layout = _search$parse$layout === undefined ? 0 : _search$parse$layout,
        _search$parse$theme = _search$parse.theme,
        theme = _search$parse$theme === undefined ? 'light' : _search$parse$theme,
        playing = _search$parse.playing;

    /**
     * @private
     * @property {number} layout
     * @property {String} theme
     * @property {Boolean} isPlaying
     */


    _this.state = { layout: layout, theme: theme, isPlaying: playing === 'true' };

    _this.switchLayout = _this.switchLayout.bind(_this);
    _this.switchTheme = _this.switchTheme.bind(_this);
    _this.togglePlaying = _this.togglePlaying.bind(_this);
    return _this;
  }

  /**
   * Switches the layout
   * @private
   */


  _createClass(SpeakerDeck, [{
    key: 'switchLayout',
    value: function switchLayout() {
      this.setState(function (prevState) {
        var layout = (prevState.layout + 1) % _layouts2.default.length;
        _url.search.write({ layout: layout });
        return { layout: layout };
      });
    }

    /**
     * Switches the theme
     * @private
     */

  }, {
    key: 'switchTheme',
    value: function switchTheme() {
      this.setState(function (prevState) {
        var theme = prevState.theme === 'dark' ? 'light' : 'dark';
        _url.search.write({ theme: theme });
        return { theme: theme };
      });
    }

    /**
     * Toggles play/pause of the timer
     * @private
     */

  }, {
    key: 'togglePlaying',
    value: function togglePlaying() {
      this.setState(function (prevState) {
        var isPlaying = !prevState.isPlaying;
        _url.search.write({ playing: isPlaying });
        return { isPlaying: isPlaying };
      });
    }

    /**
     * A button for the layout toggle
     * @private
     */

  }, {
    key: 'render',


    /**
     * @private
     * @return {Wrapper}
     *   The entire Deck inside a Wrapper
     */
    value: function render() {
      var mixin = (0, _styledComponents.css)(['', ';', ';'], this.props.mixin, presenterStyles);
      var slideNof = nOf(this.store.slideIndex, this.slides);
      var fragmentNof = nOf(this.store.fragmentIndex, this.store.fragmentHosts[this.store.slideIndex]);
      var countdown = {
        isRunning: this.state.isPlaying,
        end: this.props.timer,
        timerWarning: this.props.timerWarning || 0,
        render: _countdown.renderCountdown
      };
      var currentSrc = '' + window.location.origin + window.location.pathname + '?preview=0';
      var previewSrc = '' + window.location.origin + window.location.pathname + '?preview=1';
      return _react2.default.createElement(
        _deck.Wrapper,
        { mixin: mixin, theme: this.state.theme },
        this.plugins,
        this.elements,
        _react2.default.createElement(
          _views.Preload,
          null,
          this.speakerSlides
        ),
        _react2.default.createElement(
          _speakerWrapper2.default,
          { layout: this.state.layout },
          _react2.default.createElement(
            _controls2.default,
            { layout: this.state.layout },
            this.toggles,
            _react2.default.createElement(
              _controls.PageNumber,
              { theme: this.state.theme },
              _react2.default.createElement(
                _controls.Label,
                null,
                'Slide'
              ),
              slideNof
            ),
            _react2.default.createElement(
              _controls.FragmentNumber,
              { theme: this.state.theme },
              _react2.default.createElement(
                _controls.Label,
                null,
                'Fragment'
              ),
              fragmentNof
            ),
            _react2.default.createElement(_controls.ControlA, null),
            _react2.default.createElement(
              _controls.ControlB,
              null,
              _react2.default.createElement(
                _controls.Label,
                null,
                'Time remaining'
              ),
              _react2.default.createElement(
                _controls.Countdown,
                null,
                _react2.default.createElement(_countdown2.default, countdown)
              )
            )
          ),
          _react2.default.createElement(
            _views2.default,
            null,
            _react2.default.createElement(_views.Iframe, {
              src: currentSrc,
              height: '100%',
              width: '100%',
              frameborder: '0'
            })
          ),
          _react2.default.createElement(
            _views.Preview,
            null,
            _react2.default.createElement(_views.Iframe, {
              src: previewSrc,
              height: '100%',
              width: '100%',
              frameborder: '0'
            })
          ),
          _react2.default.createElement(
            _notes.Notes,
            null,
            _react2.default.createElement(
              _notes2.default,
              null,
              this.store.notes[this.store.slideIndex]
            )
          )
        )
      );
    }
  }, {
    key: 'layoutToggle',
    get: function get() {
      return _react2.default.createElement(_controls.LayoutToggle, {
        key: 'LayoutToggle',
        onClick: this.switchLayout,
        theme: this.state.theme
      });
    }

    /**
     * A button for the theme toggle
     * @private
     */

  }, {
    key: 'themeToggle',
    get: function get() {
      return _react2.default.createElement(_controls.ThemeToggle, {
        key: 'ThemeToggle',
        onClick: this.switchTheme,
        theme: this.state.theme,
        isDark: this.state.theme === 'dark'
      });
    }

    /**
     * A button for the countdown timer
     * @private
     */

  }, {
    key: 'playButton',
    get: function get() {
      return _react2.default.createElement(_controls.PlayButton, {
        key: 'PlayButton',
        onClick: this.togglePlaying,
        theme: this.state.theme,
        isPlaying: this.state.isPlaying
      });
    }

    /**
     * A collection of toggles
     * @private
     */

  }, {
    key: 'toggles',
    get: function get() {
      return [this.playButton, this.themeToggle, this.layoutToggle];
    }
  }, {
    key: 'speakerSlides',
    get: function get() {
      var _store = this.store,
          slideIndex = _store.slideIndex,
          fragmentOrder = _store.fragmentOrder,
          fragmentIndex = _store.fragmentIndex;

      // Get the current fragmentHost
      // and create a boolean flag to check for fragments

      var fragmentHost = this.store.fragmentHosts[slideIndex];
      var hasFragments = fragmentHost.length - fragmentIndex > 1;

      // We need a maximum of 2 slides `[current, next]`
      var filteredSlides = this.slides.filter(function (c, i) {
        return (0, _utils.range)(i, slideIndex + 1, slideIndex);
      });

      var _filteredSlides = _slicedToArray(filteredSlides, 2),
          currentSlide = _filteredSlides[0],
          _filteredSlides$ = _filteredSlides[1],
          nextSlide = _filteredSlides$ === undefined ? _react2.default.createElement(
        _slide2.default,
        null,
        'end'
      ) : _filteredSlides$;

      var currentView = (0, _react.cloneElement)(currentSlide, {
        fragmentOrder: fragmentOrder,
        slideIndex: slideIndex,
        direction: 0,
        present: true,
        isCurrent: true,
        key: 'currentView'
      });

      // The "pre-view" is either the current slide or the next slide
      // depending on the fragemnt flag
      var preView = hasFragments ? currentSlide : nextSlide;
      var nextView = (0, _react.cloneElement)(preView, {
        direction: 0,
        present: true,
        isNext: true,
        slideIndex: hasFragments ? slideIndex : slideIndex + 1,
        fragmentOrder: hasFragments ? fragmentHost[fragmentIndex + 1] : 0,
        key: 'nextView'
      });

      // Only return 2 slides
      return [currentView, nextView];
    }
  }]);

  return SpeakerDeck;
}(_deck2.default)) || _class;

exports.default = SpeakerDeck;